angular.module('ccs').directive('pageheader', pageheader)

function pageheader() {
  return {
    restrict: 'E',
    templateUrl: 'app/views/common/pageheader.html',
    scope: {
      title: '@',
      breadcrumbs: '=',
      hideSingleBreadcrumb: '@',
    },
    link: function (scope, element) {
      // Use dedicated Angular portal target to avoid conflicts with React
      const portalTarget = document.getElementById('angular-header-portal')

      if (portalTarget) {
        // Clear any existing content in the Angular portal target
        portalTarget.innerHTML = ''

        // Move the element to the portal target
        portalTarget.appendChild(element[0])

        // Clean up when the directive is destroyed
        scope.$on('$destroy', function () {
          // More robust cleanup - clear the entire portal target
          if (portalTarget) {
            portalTarget.innerHTML = ''
          }
        })
      }
    },
  }
}
